import React from "react";
import { Row, Col } from "reactstrap";
import PhoneIcon from "../../../images/call_icon.png";
const OrderViewDeliver = (props) => {
  const orderData = props.orderdetail;
  const {
    job_order_id,
    order_id,
    grand_total,
    method,
    customer_name,
    total_item_count,
    total_tray,
    customer_address,
    delivery_slot,
    telephone,
    payment_mode,
    box,
  } = orderData;

  const getAddressFrom = () => {
    const addressString = [
      "flat_villa_no",
      "building",
      "street",
      "city",
      "postcode",
    ]
      .map((key) => {
        const lables = {
          street: "Street",
          city: "City",
          flat_villa_no: "Flat",
          building: "Building",
          postcode: "Pincode",
        };
        return orderData[key] && lables[key] + ":" + orderData[key];
      })
      .filter((n) => n)
      .join(", ");

    return addressString;
  };
  return (
    <div className="delivery_order_container pt-2">
      <Row className="order_datas">
        <Col xs="2" className="order_index order_data_details">
          <span>{job_order_id}</span>
        </Col>
        <Col xs="3" className="order_data_details">
          Order ID: <p>{order_id}</p>
        </Col>
        <Col xs="3" className="order_data_details">
          Amount <p>{grand_total}</p>
        </Col>
        <Col xs="4" className="order_data_details">
          Payment Mode <p>{payment_mode}</p>
        </Col>
      </Row>
      <table className="order_data_table w-100 p-3 d-inline-block">
        <tbody className="w-100 d-inline-block">
          <tr>
            <td className="order_data_label pb-2">Customer Name:</td>
            <td className="pb-2">{customer_name}</td>
          </tr>
          <tr>
            <td className="order_data_label pb-2">Quantity:</td>
            <td className="pb-2">
              {parseInt(total_item_count)}{" "}
              {parseInt(total_item_count) > 1 ? "Items" : "Item"}{" "}
              {parseInt(box)} {parseInt(box) > 1 ? "Boxs" : "Box"}
              {/* in{" "}
              {total_tray} bag */}
            </td>
          </tr>
          <tr>
            <td className="order_data_label pb-2">Address:</td>
            <td className="pb-2">
              {getAddressFrom()}
              <br />
              {orderData.location}
            </td>
            {/* <td className="pb-2">{address.street.map((obj,k)=>(
                  <div className="d-inline" key={k}>
                    {obj}, &nbsp;
                  </div>
                ))}
                 {address.city}, {address.region},
                <p>{address.postcode}</p></td> */}
          </tr>
          <tr>
            <td className="order_data_label pb-2">Delivery Slot:</td>
            <td className="pb-2">{delivery_slot}</td>
          </tr>
          <tr>
            <td className="order_data_label pb-2">Phone:</td>
            <td className="pb-2">
              <a href={`tel:${telephone}`}>
                <img src={PhoneIcon} alt="Phone" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default OrderViewDeliver;



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/OrderViewDeliver.js